import { ITheme } from "../../utils/theme";

export const titleStyle = (theme: ITheme) => ({
  color: theme.palette.grey.A200,
  marginBottom: 1,
});

export const linkStyle = (theme: ITheme) => ({
  display: 'block',
  cursor: 'pointer',
  color: 'corporateBlue',
  mt: 1,
  mb: 2,
  '& > .MuiTypography-root': {
    fontWeight: '400'
  },
  '& > .MuiSvgIcon-root': {
    mr: theme.spacing(1),
    fill: theme.palette.corporateBlue,
    position: 'relative',
    top: '3px'
  }
})